import { render } from "./ReasonStatus.vue?vue&type=template&id=77239dfe&scoped=true&ts=true"
import script from "./ReasonStatus.vue?vue&type=script&lang=ts"
export * from "./ReasonStatus.vue?vue&type=script&lang=ts"

import "./ReasonStatus.vue?vue&type=style&index=0&id=77239dfe&scoped=true&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/open_acc_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77239dfe"]])

export default __exports__